<template>
  <Dialog
    :visible="visible"
    modal
    header="Add to karaoke queue"
    :style="{ width: '28rem' }"
    @update:visible="$emit('update:visible', $event)"
  >
    <div class="space-y-4">
      <p v-if="songTitle" class="text-sm text-gray-600 dark:text-gray-400">
        Song: <span class="font-medium text-gray-900 dark:text-white">{{ songTitle }}</span>
      </p>
      <div>
        <label for="karaoke-performer-name" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Performer name
        </label>
        <InputText
          id="karaoke-performer-name"
          v-model="performerName"
          class="w-full"
          placeholder="Enter performer name"
          @keyup.enter="confirm"
        />
      </div>
    </div>
    <template #footer>
      <Button label="Cancel" severity="secondary" @click="$emit('update:visible', false)" />
      <Button label="Add to queue" :disabled="!performerName.trim()" @click="confirm" />
    </template>
  </Dialog>
</template>

<script>
import { ref, watch } from "vue";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import InputText from "primevue/inputtext";

export default {
  name: "KaraokePerformerModal",
  components: { Dialog, Button, InputText },
  props: {
    visible: { type: Boolean, default: false },
    songTitle: { type: String, default: "" }
  },
  emits: ["update:visible", "confirm"],
  setup(props, { emit }) {
    const performerName = ref("");

    watch(
      () => props.visible,
      (open) => {
        if (open) performerName.value = "";
      }
    );

    const confirm = () => {
      const name = performerName.value.trim();
      if (!name) return;
      emit("confirm", name);
      emit("update:visible", false);
    };

    return { performerName, confirm };
  }
};
</script>
